import React, { useEffect, useState } from "react";
import Input from "../../form/Input";
import Button from "../../form/Button";
import Image from "../../elements/Image";
import Background from "../../../assets/image/background.jpg";
import Screenshot from "../../../assets/image/demo-screenshot.png";
import { postData } from "../../../services/api";
import toastr from "toastr";
import { Link } from 'react-router-dom';
import SchedualeDemoPopup from "../../popup/SchedualeDemoPopup";
import { MAIN_LOGO } from "../../../constant/Constant";

const IntroContent = ({ type,segment }) => {
  const [loading, setLoading] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [pageData, setPageData] = useState({});
  const [scheduleDemoPopup, setScheduleDemoPopup] = useState(false);
  const [firstChunk, setFirstChunk] = useState([]);
  const [secondChunk, setSecondChunk] = useState([]);
  const [chunkValue, setChunkData] = useState([]);
  const [lastchunkValue, setLastChunkData] = useState([]);
  const [pageData2, setPageData2] = useState({});
  const [pageData3, setPageData3] = useState({});
  const handelSubmit = async () => {
    setLoading(true);
    try {
      const result = await postData("/enquery/create", {
        type: 3,
        full_name: fullName,
        email: email,
        phone: phone,
        leadPath : segment
      });
      if (result.status === 200) {
        setLoading(false);
        setEmail("");
        setPhone("");
        setFullName("");
        toastr.success(result.message)
      } else {
        setLoading(false);
        toastr.error(result.message)
      }
    } catch (e) {
      setLoading(false);
      toastr.error(e.message)
    }
  };

  const chunk = (array, size) =>
    array.reduce((acc, _, i) => {
      if (i % size === 0) acc.push(array.slice(i, i + size))
      return acc
    }, [])

  useEffect(() => {
    const loadPageDetails = async () => {
      let slug = '';
      if (type === 2) {
        slug = 'intro2';
      } else if (type === 3) {
        slug = 'intro3';
      } else if (type === 4) {
        slug = 'succession-planing-intro4';
      }

      try {
        const result = await postData("/lead-content/details", {
          slug: slug
        });
        if (result.data) {
          if (Array.isArray(result.data.content)) {
            setPageData(result.data);
            //const numbers = Array.isArray(result.data.content) && result.data.content;
            let chunked = result.data.content.slice(0, 3)
            let chunked2 = result.data.content.slice(3, 6)
            setFirstChunk(chunked)
            setSecondChunk(chunked2)
          }
          if (type === 4) {
            const result2 = await postData("/lead-content/details", {
              slug: 'business-intro4'
            });
            if (Array.isArray(result2.data.content)) {
              const numbers = result2.data.content
              const chunked3 = chunk(numbers, 3)
              setChunkData(chunked3)
              setPageData2(result2.data)
            }

            const result3 = await postData("/lead-content/details", {
              slug: 'number-intro4'
            });

            if (Array.isArray(result3.data.content)) {
              setLastChunkData(result3.data.content)
              setPageData3(result3.data)
            }


          }
        }
        if (type === 6) {
          const intro6 = await postData("/lead-content/details", {
            slug: 'leader-say-intro6'
          });

          setPageData(intro6.data);

          const intro62 = await postData("/lead-content/details", {
            slug: 'succssion-planing-intro6'
          });

          setPageData2(intro62.data);

          const intro63 = await postData("/lead-content/details", {
            slug: 'number-intro6'
          });

          setPageData3(intro63.data);
        }

      } catch (err) {
        console.log(err.message);
      }
    };
    loadPageDetails();
  }, [type]);

  return (
    <>
      {type === 4 && (
        <>
          <section className="relative w-full bg-white py-10 lg:py-16 xl:py-20 z-0 overflow-hidden border-b border-slate-100">
            <div className={"mb-10 lg:mb-20 flex items-center justify-center max-w-[1160px] mx-auto"}>
                  <Link to={"/"}>
                            <div className="h-14 w-full flex justify-center object-contain mb-5">
                              <Image
                                src={MAIN_LOGO}
                                alt={""}
                                width={"100%"}
                                height={"100%"}
                                classes={"object-contain object-center"}
                              />
                            </div>
                          </Link>
            </div>
            <div className="absolute z-[-1] w-full h-full top-0 left-0 opacity-75 after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:left-0">
              <Image src={Background} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
            </div>
            <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
              <div className="space-y-12">
                <div className="relative space-y-5">
                  <h2 className="xl:text-4xl text-3xl font-bold text-dark-teal-400 tracking-tight">{pageData.description}</h2>
                  <div className="grid sm:grid-cols-3 gap-4 lg:gap-8">
                    {Array.isArray(firstChunk) && firstChunk.map((it, i) => {
                      return (
                        <div className="relative flex">
                          <div className="w-full justify-between flex  flex-col bg-white border border-slate-200 rounded px-6 py-10">
                            <div className="space-y-2 flex flex-col justify-between text-slate-600 leading-tight text-sm xl:text-base">{it.title}</div>
                            <div className="text-xs xl:text-sm text-slate-500 mt-1">{it.creator}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="!mt-10 flex justify-center">
                    <Button
                      buttonHasLink={false}
                      buttonLabel={"View the Demo"}
                      buttonLabelClasses={"!text-xl"}
                      buttonClasses={"!h-12 !px-10 hover:!bg-teal-600"}
                      functions={() => { setScheduleDemoPopup(true) }}
                    />
                  </div>
                </div>
                <div className="relative space-y-5">
                  <div className="grid sm:grid-cols-3 gap-4 lg:gap-8">
                    {Array.isArray(secondChunk) && secondChunk.map((it, i) => {
                      return (
                        <div className="relative flex">
                          <div className="w-full justify-between flex  flex-col bg-white border border-slate-200 rounded px-6 py-10">
                            <div className="space-y-2 flex flex-col justify-between text-slate-600 leading-tight text-sm xl:text-base">{it.title}</div>
                            <div className="text-xs xl:text-sm text-slate-500 mt-1">{it.creator}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="!mt-10 flex justify-center">
                    <Button
                      buttonHasLink={false}
                      buttonLabel={"View the Demo"}
                      buttonLabelClasses={"!text-xl"}
                      buttonClasses={"!h-12 !px-10 hover:!bg-teal-600"}
                      functions={() => { setScheduleDemoPopup(true)}}
                    />
                  </div>
                </div>
                <div className="relative space-y-5">
                  <h2 className="xl:text-4xl text-3xl font-bold text-dark-teal-400 tracking-tight">{pageData2.description}</h2>
                  <div className="grid sm:grid-cols-3 gap-4 lg:gap-8">
                    <div className="relative flex">
                      <div className="w-full flex bg-white border border-slate-200 rounded px-6 py-10">
                        <div className="space-y-3 flex flex-col justify-between">
                          <div className="text-base text-slate-900 uppercase font-semibold">Continuity</div>
                          <div className="space-y-1">
                            {Array.isArray(chunkValue[0]) && chunkValue[0].map((it, i) => {
                              return (<div className="text-sm xl:text-base text-slate-500">{it.title}</div>);
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="relative flex">
                      <div className="w-full flex bg-white border border-slate-200 rounded px-6 py-10">
                        <div className="space-y-3 flex flex-col justify-between">
                          <div className="text-base text-slate-900 uppercase font-semibold">Employee Retention</div>
                          <div className="space-y-1">
                            {Array.isArray(chunkValue[1]) && chunkValue[1].map((it, i) => {
                              return (<div className="text-sm xl:text-base text-slate-500">{it.title}</div>);
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="relative flex">
                      <div className="w-full flex bg-white border border-slate-200 rounded px-6 py-10">
                        <div className="space-y-3 flex flex-col justify-between">
                          <div className="text-base text-slate-900 uppercase font-semibold">Growth</div>
                          <div className="space-y-1">
                            {Array.isArray(chunkValue[2]) && chunkValue[2].map((it, i) => {
                              return (<div className="text-sm xl:text-base text-slate-500">{it.title}</div>);
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="!mt-10 flex justify-center">
                    <Button
                      buttonHasLink={false}
                      buttonLabel={"View the Demo"}
                      buttonLabelClasses={"!text-xl"}
                      buttonClasses={"!h-12 !px-10 hover:!bg-teal-600"}
                      functions={() => { setScheduleDemoPopup(true) }}
                    />
                  </div>
                </div>
                <div className="relative space-y-5">
                  <h2 className="xl:text-4xl text-3xl font-bold text-dark-teal-400 tracking-tight">{pageData3.description}</h2>
                  <div className="grid sm:grid-cols-3 gap-4 lg:gap-8">
                    {Array.isArray(lastchunkValue) && lastchunkValue.map((it, i) => {
                      return (
                        <div className="relative flex">
                          <div className="w-full justify-between flex  flex-col bg-white border border-slate-200 rounded px-6 py-10">
                            <div className="space-y-2 flex flex-col text-slate-600 justify-between leading-tight text-sm xl:text-base">{it.title}</div>
                            <div className="text-xs xl:text-sm text-slate-500 mt-1">{it.creator}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="!mt-10 flex justify-center">
                    <Button
                      buttonHasLink={false}
                      buttonLabel={"View the Demo"}
                      buttonLabelClasses={"!text-xl"}
                      buttonClasses={"!h-12 !px-10 hover:!bg-teal-600"}
                      functions={() => { setScheduleDemoPopup(true) }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          { scheduleDemoPopup &&
            <SchedualeDemoPopup
              isOpen={scheduleDemoPopup}
              setIsOpen={(val) => setScheduleDemoPopup(val)}
              data={''}
              getActionValue={(obj) => {
                // setActionValue(obj);
                // setIsUpdate(true);
              }}
            ></SchedualeDemoPopup>
          }
        </>
      )
      }
      {type === 6 && (
        <section className="relative w-full bg-white py-10 lg:py-16 xl:py-20 z-0 overflow-hidden border-b border-slate-100">
          <div className={"mb-10 lg:mb-20 flex items-center justify-center max-w-[1160px] mx-auto"}>
          <Link to={"/"}>
              <div className="h-14 w-full flex justify-center object-contain mb-5">
                <Image
                  src={MAIN_LOGO}
                  alt={""}
                  width={"100%"}
                  height={"100%"}
                  classes={"object-contain object-center"}
                />
              </div>
            </Link>
          </div>
          <div className="absolute z-[-1] w-full h-full top-0 left-0 opacity-75 after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:left-0">
            <Image src={Background} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
          </div>
          <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
            <div className="flex justify-center flex-wrap lg:flex-nowrap gap-10 xl:gap-20 2xl:gap-32">
              <div className="w-full">
                <div className="relative space-y-4 lg:space-y-10">
                  <h2 className="mb-3 lg:mb-6 block text-xl sm:text-2xl xl:text-3xl 3xl:text-4xl font-bold text-dark-teal-400 tracking-tight">{pageData.description}</h2>
                  <ul className="pl-8 space-y-5">
                    {(pageData?.content && pageData?.content.length > 0) && pageData?.content.map((item, index) => (
                      <li key={index} className="relative font-semibold text-black border border-slate-200 p-3 bg-white rounded-xl before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:top-2 before:-left-8">
                        <span className="flex leading-tight text-sm xl:text-base">{item?.title}</span>
                        <span className="flex justify-end text-xs text-slate-400 font-normal mt-1">- {item?.creator}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="w-full">
                <div className="relative space-y-4 lg:space-y-10">
                  <h2 className="mb-3 lg:mb-6 block text-xl sm:text-2xl xl:text-3xl 3xl:text-4xl font-bold text-dark-teal-400 tracking-tight">{pageData2.description}</h2>
                  <ul className="pl-8 space-y-5">
                    {(pageData2?.content && pageData2?.content.length > 0) && pageData2?.content.map((item, index) => (
                      <li key={index} className="relative font-semibold text-black border border-slate-200 p-3 bg-white rounded-xl before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:top-2 before:-left-8">
                        <span className="flex leading-tight">{item?.title}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="w-full">
                <div className="relative space-y-4 lg:space-y-10">
                  <h2 className="mb-3 lg:mb-6 block text-xl sm:text-2xl xl:text-3xl 3xl:text-4xl font-bold text-dark-teal-400 tracking-tight">{pageData3.description}</h2>
                  <ul className="pl-8 space-y-5">
                    {(pageData3?.content && pageData3?.content.length > 0) &&
                      pageData3?.content.map((item, index) => (
                        <li key={index} className="relative font-semibold text-black border border-slate-200 p-3 bg-white rounded-xl before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:top-2 before:-left-8">
                          <span className="flex leading-tight">{item?.title}</span>
                          <span className="flex justify-end text-xs text-slate-400 font-normal">- {item?.creator}</span>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto mt-20">
            <div className="flex justify-center flex-wrap lg:flex-nowrap gap-10 xl:gap-20 2xl:gap-32">
              <div className="w-full lg:w-1/2 xl:w-5/12">
                <div className="relative space-y-10">
                  <div className="space-y-4">
                    <h2 className="xl:text-5xl text-3xl font-bold text-dark-teal-400 tracking-tight">View Demo</h2>
                    <h4 className="text-lg text-black leading-tight">See why SuccessionNow is the #1 succession planning software.</h4>
                  </div>
                  <div className="relative space-y-5">
                    <div className="relative">
                      <Input
                        labelClasses={"!text-white font-light"}
                        inputType={"text"}
                        inputClasses={
                          "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                        }
                        inputPlaceholder={"Full Name"}
                        inputValue={fullName}
                        inputName={""}
                        errorType={""}
                        isDisabled={false}
                        setInput={setFullName}
                      />
                    </div>
                    <div className="relative">
                      <Input
                        labelClasses={"!text-white font-light"}
                        inputType={"email"}
                        inputClasses={
                          "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                        }
                        inputPlaceholder={"Work Email"}
                        inputValue={email}
                        inputName={""}
                        errorType={""}
                        setInput={setEmail}
                      />
                    </div>
                    <div className="relative">
                      <Input
                        labelClasses={"!text-white font-light"}
                        inputType={"text"}
                        inputClasses={
                          "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                        }
                        inputPlaceholder={"Phone Number"}
                        inputValue={phone}
                        inputName={""}
                        errorType={""}
                        setInput={setPhone}
                      />
                    </div>
                    <div className="relative md:col-span-2">
                      <div className="flex justify-center mt-8">
                        <Button
                          buttonClasses="!bg-dark-teal-700 hover:!bg-dark-teal-900 !px-6 !w-full !h-14 !text-xl rounded-lg"
                          buttonLabelClasses="!text-xl"
                          buttonType={"button"}
                          buttonLabel={"View Demo"}
                          buttonIcon={
                            loading
                              ? "fa-light fa-spinner fa-spin"
                              : ""
                          }
                          buttonIconPosition={"left"}
                          functions={handelSubmit}
                          buttonHasLink={false}
                          buttonDisabled={loading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="h-40 sm:h-72 md:h-96 lg:h-[440px] flex">
            <div className="absolute w-full max-w-[1024px] px-6 xl:px-0 bottom-0 left-1/2 -translate-x-1/2 flex">
              <div className="absolute z-[1] w-full h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-solid fa-play"}
                  buttonIconPosition={"left"}
                  buttonClasses={"!w-16 !h-16 !p-0 !rounded-full !text-3xl !mt-16 hover:!bg-teal-600 !shadow-lg"}
                  functions={() => { }}
                />
              </div>
              <Image src={Screenshot} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
            </div>
          </div>
        </section>
      )}
      {type !== 4 && type !== 6 && (
        <>
          <section className="relative w-full bg-white py-10 lg:py-16 xl:py-20 z-0 overflow-hidden border-b border-slate-100">
            <div className={"mb-10 lg:mb-20 flex items-center justify-center max-w-[1160px] mx-auto"}>
            <Link to={"/"}>
              <div className="h-14 w-full flex justify-center object-contain mb-5">
                <Image
                  src={MAIN_LOGO}
                  alt={""}
                  width={"100%"}
                  height={"100%"}
                  classes={"object-contain object-center"}
                />
              </div>
            </Link>
            </div>
            <div className="absolute z-[-1] w-full h-full top-0 left-0 opacity-75 after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:left-0">
              <Image src={Background} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
            </div>
            <div className="w-full px-4 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
              <div className="flex justify-center flex-wrap lg:flex-nowrap gap-10 xl:gap-20 2xl:gap-32">
                <div className="w-full lg:w-1/2 xl:w-5/12">
                  <div className="relative w-full max-w-md lg:max-w-none mx-auto space-y-10">
                    <div className="space-y-4">
                      <h2 className="xl:text-5xl text-3xl font-bold text-dark-teal-400 tracking-tight">View Demo</h2>
                      <h4 className="text-lg text-black leading-tight">See why SuccessionNow is the #1 succession planning software.</h4>
                    </div>
                    <div className="relative space-y-5">
                      <div className="relative">
                        <Input
                          labelClasses={"!text-white font-light"}
                          inputType={"text"}
                          inputClasses={
                            "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                          }
                          inputPlaceholder={"Full Name"}
                          inputValue={fullName}
                          inputName={""}
                          errorType={""}
                          isDisabled={false}
                          setInput={setFullName}
                        />
                      </div>
                      <div className="relative">
                        <Input
                          labelClasses={"!text-white font-light"}
                          inputType={"email"}
                          inputClasses={
                            "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                          }
                          inputPlaceholder={"Work Email"}
                          inputValue={email}
                          inputName={""}
                          errorType={""}
                          setInput={setEmail}
                        />
                      </div>
                      <div className="relative">
                        <Input
                          labelClasses={"!text-white font-light"}
                          inputType={"text"}
                          inputClasses={
                            "h-12 rounded-lg focus:!border-dark-teal-300 focus:!bg-slate-50"
                          }
                          inputPlaceholder={"Phone Number"}
                          inputValue={phone}
                          inputName={""}
                          errorType={""}
                          setInput={setPhone}
                        />
                      </div>
                      <div className="relative md:col-span-2">
                        <div className="flex justify-center mt-8">
                          <Button
                            buttonClasses="!bg-dark-teal-700 hover:!bg-dark-teal-900 !px-6 !w-full !h-14 !text-xl rounded-lg"
                            buttonLabelClasses="!text-xl"
                            buttonType={"button"}
                            buttonLabel={"View Demo"}
                            buttonIcon={
                              loading
                                ? "fa-light fa-spinner fa-spin"
                                : ""
                            }
                            buttonIconPosition={"left"}
                            functions={handelSubmit}
                            buttonHasLink={false}
                            buttonDisabled={loading}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full lg:w-1/2 xl:w-5/12">
                  <div className="relative space-y-10">
                    <h2 className="mb-6 block text-3xl xl:text-5xl 2xl:text-6xl font-bold text-dark-teal-400 tracking-tight">
                      {(pageData?.description) ? pageData?.description : ''}
                    </h2>
                    { (type && type === 2) &&
                      <ul className="pl-8 space-y-5">
                        {(pageData?.content && pageData?.content.length > 0) &&
                          pageData?.content.map((item, index) => (
                            <li key={index} className="relative font-semibold text-black border border-slate-200 p-3 bg-white rounded-xl before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:top-2 before:-left-8">
                              <span className="flex leading-tight text-sm xl:text-base">{item?.title}</span>
                              <span className="flex justify-end text-xs text-slate-400 font-normal mt-1">- {item?.creator}</span>
                            </li>
                          ))
                        }
                      </ul>
                    }
                    {(type && type === 3) &&
                      <ul className="pl-8 grid grid-cols-2 gap-y-5 gap-x-10">
                        {(pageData?.content && pageData?.content.length > 0) &&
                          pageData?.content.map((item, index) => (
                            <li key={index} className="relative font-semibold text-sm xl:text-base text-black leading-tight before:content-[''] before:bg-[url('assets/icon/check-circle.svg')] before:bg-contain before:absolute before:w-6 before:h-6 before:-top-[3px] before:-left-8">{item?.title}</li>
                          ))
                        }
                      </ul>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className="h-40 sm:h-72 md:h-96 lg:h-[440px] flex">
              <div className="absolute w-full max-w-[1024px] px-6 xl:px-0 bottom-0 left-1/2 -translate-x-1/2 flex">
                <div className="absolute z-[1] w-full h-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
                  <Button
                    buttonHasLink={false}
                    buttonIcon={"fa-solid fa-play"}
                    buttonIconPosition={"left"}
                    buttonClasses={"!w-16 !h-16 !p-0 !rounded-full !text-3xl !mt-16 hover:!bg-teal-600 !shadow-lg"}
                    functions={() => { }}
                  />
                </div>
                <Image src={Screenshot} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"flex object-cover"} />
              </div>
            </div>
          </section>
        </>
      )
      }

    </>
  );
};

export default IntroContent;